import { createFileRoute } from '@tanstack/react-router';
import { SignedOutPage } from '@/features/session';
import { SignedOutSearchSchema } from '@/features/session/search';

/** Public: shown after sign-out and when a sign-in did not complete (no session required). */
export const Route = createFileRoute('/signed-out')({
  validateSearch: (search) => SignedOutSearchSchema.parse(search),
  component: SignedOutRoute,
});

function SignedOutRoute() {
  const { reason } = Route.useSearch();
  return <SignedOutPage reason={reason} />;
}
